import React from 'react';
import PropTypes, { any } from 'prop-types';

import { wonSet } from '../../../utils';
import { position1winner } from '../../../utils/V2/postScore';
import { showMatchWinner, showOutcome } from '../../../utils/postScore';
import { WalkOverValues, RetiredValues, PlayerTypes, OutComeTypes, CompletionTypes, ForfeitValues } from '../../../utils/postScoreConstants';
import { titleCase } from '../../../utils/formatting';

const DisplayScoreV2 = (props) => {
    const { match, position, playersDictByMemberId, teamsDict } = props;

    const getScores = (score, playerType) => {
        if (score && playerType) {
            const scoreArray = Object.values(score);
            if (scoreArray.length > 0) {
                return (
                    <>
                        {scoreArray.map((scoreItem, i) => {
                            return (
                                <div
                                    className={`score-item ${showMatchWinner(match.result?.outcome, match.result?.completionType) ? wonSet(scoreItem, playerType) ? PlayerTypes.WINNER : '' : ''}`}
                                    key={`score-item-${i}`}
                                >
                                    {playerType === PlayerTypes.WINNER ? scoreItem.winner || 0 : scoreItem.loser || 0}
                                    {(scoreItem.tiebreak != null && scoreItem.tiebreak >= 0) && (
                                        <sup>{playerType === PlayerTypes.WINNER ? scoreItem.winnerTiebreak : scoreItem.tiebreak }</sup>
                                    )}
                                </div>
                            );
                        })}
                    </>
                );
            }

            if (playerType === PlayerTypes.LOSER && (WalkOverValues.includes(match.result.outcome) || match.result.completionType === CompletionTypes.WINNER_DID_NOT_START) && showOutcome(match.result?.outcome)) {
                return (
                    <span className="outcome-font">{match.result.outcome ? titleCase(match.result.outcome) : 'Walkover'}</span>
                );
            }
        }
    };
    const isPosition1winner = position1winner(match, playersDictByMemberId, teamsDict);

    return (
        position === 'position1' ? (
            <div className="card-score-display position1">
                <div className="scores-container">
                    {isPosition1winner ? getScores(match.result.score, PlayerTypes.WINNER) : getScores(match.result.score, PlayerTypes.LOSER)}
                </div>
                <div className="winner-display-conatiner">
                    {isPosition1winner && showMatchWinner(match.result.outcome, match.result.completionType) && (
                        <div className="winning-scores" />
                    )}
                </div>
            </div>
        ) : (
            <>
                <div className="card-score-display mt8">
                    <div className="scores-container">
                        {isPosition1winner ? getScores(match.result.score, PlayerTypes.LOSER) : getScores(match.result.score, PlayerTypes.WINNER)}
                    </div>
                    <div className="winner-display-conatiner">
                        {!isPosition1winner && showMatchWinner(match.result.outcome, match.result.completionType) && (
                            <div className="winning-scores" />
                        )}
                    </div>
                </div>
                {/* display if retired after position2 score */}
                {(RetiredValues.includes(match.result.outcome) || ForfeitValues.includes(match.result.outcome) ||
                    match.result?.outcome === OutComeTypes.ABANDONED || match.result?.outcome === OutComeTypes.DOUBLEWALKOVER || match.result?.outcome === OutComeTypes.DEFAULTED || match.result?.outcome === OutComeTypes.WITHDREW) && (
                        <div className={`score-outcome-label no-wrap`}>{titleCase(match.result.outcome)}</div>
                    )}
            </>
        )
    );
};

DisplayScoreV2.propTypes = {
    match: PropTypes.objectOf(any).isRequired,
    playersDictByMemberId: PropTypes.objectOf(any).isRequired,
    teamsDict: PropTypes.objectOf(any).isRequired,
    position: PropTypes.string.isRequired,
};

export default DisplayScoreV2;
